import BotonManualHeader from "../../components/BotonManualHeader";
import React, { useState, useEffect } from "react";

import {
  Container,
  Card,
  Form,
  Button,
  Row,
  Col,
  Table,
  Badge,
  Spinner,
  Alert,
  InputGroup,
  ProgressBar,
  Modal,
  Tabs,
  Tab,
  OverlayTrigger,
  Tooltip
} from "react-bootstrap";
import {
  FaSearch,
  FaFileAlt,
  FaCheck,
  FaEdit,
  FaEye,
  FaFileSignature,
  FaIdCard,
  FaRegClock,
  FaUpload,
  FaInfoCircle,
  FaSignature,
  FaDownload,
  FaExclamationTriangle,
  FaHashtag,
  FaUsers,
  FaChartPie,
  FaTimes,
  FaCog,
  FaTrash,
  FaFilePdf
} from "react-icons/fa";
import * as FaIcons from "react-icons/fa";
import { exportarToPDF } from "../../functions/exportarToPDF";
import getReporteOnboarding from "../../functions/getReporteOnboarding";
import swal from "sweetalert2";
import {
  getFirestore,
  collection,
  getDocs,
  getDoc,
  doc,
  deleteDoc
} from "firebase/firestore";
import { getStorage, ref, deleteObject } from "firebase/storage";
import firebaseApp from "../../firebase/credenciales";
import Swal from "sweetalert2";
import { checkPermission } from "../../functions/checkPermission";
import { logBusinessAction } from "../../services/AuditService";

const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);

function SeguimientoOnboarding({ usuario }) {
  // Estados
  const [loading, setLoading] = useState(false);
  const [buscando, setBuscando] = useState(false);
  const [dni, setDni] = useState("");
  const [datosUsuario, setDatosUsuario] = useState(null);
  const [documentos, setDocumentos] = useState([]);
  const [documentosAsignados, setDocumentosAsignados] = useState([]);
  const [error, setError] = useState(null);
  const [documentosMaestros, setDocumentosMaestros] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [documentoSeleccionado, setDocumentoSeleccionado] = useState(null);
  const [loadingMaestros, setLoadingMaestros] = useState(true);
  const [activeTab, setActiveTab] = useState('todos');
  const [mesReporte, setMesReporte] = useState(String(new Date().getMonth() + 1));
  const [anoReporte, setAnoReporte] = useState(String(new Date().getFullYear()));
  const [exportando, setExportando] = useState(false);
  const [progreso, setProgreso] = useState(0);
  
  // Estados para Reporte Masivo
  const [ambitoReporte, setAmbitoReporte] = useState("individual"); // 'individual' o 'masivo'
  const [documentoMasivo, setDocumentoMasivo] = useState(""); // Nombre del documento para reporte masivo

  // Cargar lista maestra de documentos al inicio
  useEffect(() => {
    cargarDocumentosMaestros();
  }, [usuario.ruc]);

  // Función para cargar documentos maestros
  const cargarDocumentosMaestros = async () => {
    try {
      setLoadingMaestros(true);
      const rucEmpresa = usuario.ruc || "20538856674";
      const documentosRef = collection(db, `onboarding_lista/${rucEmpresa}/documentos`);
      const documentosSnap = await getDocs(documentosRef);
      const listaDocumentos = [];
      documentosSnap.forEach((doc) => {
        listaDocumentos.push({
          id: doc.id,
          ...doc.data()
        });
      });
      setDocumentosMaestros(listaDocumentos);
      if (listaDocumentos.length === 0) {
        console.warn("No se encontraron documentos en la lista maestra para el RUC:", rucEmpresa);
      }
    } catch (error) {
      console.error("Error al cargar documentos maestros:", error);
      setError("Error al cargar la lista maestra de documentos");
    } finally {
      setLoadingMaestros(false);
    }
  };

  // Reintento de carga si usuario.ruc cambia
  useEffect(() => {
    if (usuario?.ruc && documentosMaestros.length === 0) {
        cargarDocumentosMaestros();
    }
  }, [usuario?.ruc, documentosMaestros.length]);

  // Función de búsqueda por DNI
  const buscarPorDNI = async () => {
    if (!dni.trim() || dni.length < 8) {
      setError("Ingrese un número de DNI válido");
      return;
    }

    try {
      setBuscando(true);
      setError(null);
      setDocumentos([]);
      setDocumentosAsignados([]);
      setDatosUsuario(null);

      // Obtener datos del usuario
      const userRef = doc(db, "users", dni.trim());
      const userSnap = await getDoc(userRef);

      if (userSnap.exists()) {
        setDatosUsuario(userSnap.data());
      } else {
        setError(`No se encontró usuario con DNI: ${dni}`);
        setBuscando(false);
        return;
      }

      // 1. Obtener documentos ASIGNADOS (onboarding/{dni}/documentos)
      const docsAsignadosRef = collection(db, `onboarding/${dni.trim()}/documentos`);
      const docsAsignadosSnap = await getDocs(docsAsignadosRef);

      const asignados = [];
      docsAsignadosSnap.forEach(doc => {
        const data = doc.data();
        if (data.activo) {
          asignados.push({
            id: doc.id,
            ...data,
            origen: "asignado",
            estado: data.completed ? "completado" : "pendiente"
          });
        }
      });

      setDocumentosAsignados(asignados);

      // 2. Obtener documentos PROCESADOS (onboarding/{dni}/legajo)
      const legajoRef = collection(db, `onboarding/${dni.trim()}/legajo`);
      const legajoSnap = await getDocs(legajoRef);

      const procesados = [];
      legajoSnap.forEach(doc => {
        const data = doc.data();
        procesados.push({
          id: doc.id,
          ...data,
          origen: "legajo",
          estado: data.linkFirmado
            ? "firmado"
            : data.fechaVista
              ? "visto"
              : data.contador > 0
                ? "visto"
                : "pendiente",
          firmado: !!data.linkFirmado,
          fechaMostrar: data.fechaFirma || data.fechaVista || data.fechaDoc || null
        });
      });

      // 3. Combinar documentos
      const todosDocumentos = [];
      const asignadosVistos = new Set();

      // A. Primero procesar todos los documentos del legajo (completados/vistos)
      procesados.forEach(docProcesado => {
        // Buscar si corresponde a un documento asignado
        const asignadoCorrespondiente = asignados.find(
          doc =>
            doc.id === docProcesado.documentId ||
            doc.idDocument === docProcesado.documentId
        );

        if (asignadoCorrespondiente) {
          // Es una respuesta a una asignación (puede haber múltiples por ID)
          asignadosVistos.add(asignadoCorrespondiente.id);

          todosDocumentos.push({
            ...asignadoCorrespondiente, // Heredar metadatos del asignado
            ...docProcesado,            // Sobrescribir con datos del proceso
            origen: "legajo",           // Marcar como origen legajo (instancia específica)
            legajoId: docProcesado.id,  // ID único del documento en legajo
            assignedId: asignadoCorrespondiente.id, // Referencia al ID de asignación
            estado: "completado",       // Si está en legajo, ya no es pendiente
            firmado: !!docProcesado.linkFirmado,
            fechaMostrar: docProcesado.fechaFirma || docProcesado.fechaVista || docProcesado.fechaDoc || null
          });
        } else {
          // Documento extra no asignado previamente
          todosDocumentos.push({
            ...docProcesado,
            origen: "legajo",
            legajoId: docProcesado.id,
            title: docProcesado.nombre || docProcesado.tipo || "Documento sin título",
            type: docProcesado.tipo === "Firma Digital" ? "sign" : "upload",
            estado: "completado",
            firmado: !!docProcesado.linkFirmado,
            fechaMostrar: docProcesado.fechaFirma || docProcesado.fechaVista || docProcesado.fechaDoc || null
          });
        }
      });

      // B. Luego agregar las asignaciones que NO tienen ningún documento en legajo (Pendientes)
      asignados.forEach(docAsignado => {
        if (!asignadosVistos.has(docAsignado.id)) {
          todosDocumentos.push({
            ...docAsignado,
            origen: "asignado",
            estado: "pendiente"
          });
        }
      });

      // Ordenar documentos por fecha (más reciente primero) y luego por ID
      todosDocumentos.sort((a, b) => {
        // Helper para obtener timestamp
        const getTimestamp = (doc) => {
          const fecha = doc.fechaMostrar || doc.fechaFirma || doc.fechaVista || doc.fechaDoc;
          if (!fecha) return 0;
          if (fecha.toDate) return fecha.toDate().getTime(); // Firestore Timestamp
          return new Date(fecha).getTime(); // String/Date
        };

        const timeA = getTimestamp(a);
        const timeB = getTimestamp(b);

        // Si ambas tienen fecha, ordenar descendente (más nuevo primero)
        if (timeA !== timeB) {
          return timeB - timeA;
        }

        // Fallback a ID si no hay fecha o son iguales
        const idA = obtenerIdNumerico(a);
        const idB = obtenerIdNumerico(b);
        return idA - idB;
      });

      // 4. Filtrar por permisos granulares (Evitar que médicos vean documentos no médicos, etc.)
      const documentosFiltradosPorPermiso = todosDocumentos.filter(doc => {
        const idDoc = String(doc.documentId || doc.idDocument || doc.id);
        
        // EXCLUIR EXÁMENES MÉDICOS (ID 9 y 32) de Seguimiento Onboarding
        if (idDoc === "9" || idDoc === "32") {
          return false;
        }

        const titulo = (doc.title || doc.nombre || "").toLowerCase();
        // Identificar documentos médicos/sensibles
        const esMedico = titulo.includes("médico") || titulo.includes("médica") || titulo.includes("salud");
        
        // Si es médico, requiere el permiso específico
        if (esMedico) {
          return checkPermission(usuario, 'onboarding', 'MEDICO_OCUPACIONAL');
        }

        // Para otros documentos, seguir con el permiso granular normal por ID
        return checkPermission(usuario, 'onboarding', idDoc);
      });

      setDocumentos(documentosFiltradosPorPermiso);

      // Calcular progreso con la lista filtrada
      calcularProgreso(documentosFiltradosPorPermiso);
    } catch (error) {
      console.error("Error al buscar trabajador:", error);
      setError("Error al consultar el trabajador");
    } finally {
      setBuscando(false);
    }
  };

  const handleExportarPDF = async () => {
    if (ambitoReporte === "individual" && !datosUsuario) {
      swal.fire("Error", "Busque un trabajador para generar el reporte individual", "error");
      return;
    }

    if (ambitoReporte === "masivo" && !documentoMasivo) {
      swal.fire("Error", "Seleccione un documento para el reporte masivo", "error");
      return;
    }

    try {
      setExportando(true);
      const rucActual = usuario.ruc || datosUsuario?.rucEmpresa;
      
      const registros = await getReporteOnboarding(
        rucActual,
        ambitoReporte === "individual" ? dni : null,
        mesReporte,
        anoReporte,
        datosUsuario,
        false, // soloMedico = false
        ambitoReporte === "masivo" ? documentoMasivo : null
      );

      if (registros.length === 0) {
        const msg = ambitoReporte === "individual" 
          ? `No se encontraron documentos en ${mesReporte}/${anoReporte}`
          : `Nadie recibió el documento "${documentoMasivo}" en ${mesReporte}/${anoReporte}`;
        swal.fire("Sin datos", msg, "info");
        setExportando(false);
        return;
      }

      const pdfBytes = await exportarToPDF(registros, rucActual);
      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      const nombreArchivo = ambitoReporte === "individual"
        ? `Reporte_Onboarding_${dni}_${mesReporte}_${anoReporte}.pdf`
        : `Reporte_Masivo_${documentoMasivo.replace(/ /g, "_")}_${mesReporte}_${anoReporte}.pdf`;
      
      a.download = nombreArchivo;
      a.click();
      URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Error PDF Onboarding:", error);
      swal.fire("Error", "No se pudo generar el PDF", "error");
    } finally {
      setExportando(false);
    }
  };

  // Calcular progreso
  const calcularProgreso = (docs) => {
    if (!docs.length) {
      setProgreso(0);
      return;
    }

    // Solo considerar documentos obligatorios
    const documentosObligatorios = docs.filter(doc => doc.obligatorio);
    const listaParaCalculo = documentosObligatorios.length > 0 ? documentosObligatorios : docs;

    const completados = listaParaCalculo.filter(doc => {
      // Regla 1: Si requiere firma, DEBE tener linkFirmado o estar en estado firmado
      if (doc.type === 'sign') {
        return !!doc.linkFirmado || doc.estadoEnLegajo === "firmado";
      }

      // Regla 2: Si es de carga/lectura, basta con estar en legajo o completado
      return (
        doc.estado === "completado" ||
        (doc.origen === "legajo")
      );
    }).length;

    setProgreso(Math.round((completados / listaParaCalculo.length) * 100));
  };

  // Función para eliminar documento
  const eliminarDocumento = async (documento) => {
    // Texto de confirmación depende del origen
    const esInstanciaLegajo = documento.origen === "legajo";
    const textoAdvertencia = esInstanciaLegajo
      ? `Estás eliminando un documento ya procesado/firmado. La asignación original permanecerá pendiente si no hay otros.`
      : `Estás eliminando la ASIGNACIÓN de este documento. El trabajador ya no verá este requisito.`;

    const result = await Swal.fire({
      title: '¿Estás seguro?',
      text: `${textoAdvertencia} ¿Deseas continuar?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    });

    if (!result.isConfirmed) return;

    try {
      setLoading(true);

      // 1. Eliminar archivos del storage si existen
      if (documento.link) {
        try {
          // Extraer la ruta del archivo desde el link (asumiendo que es una URL de Firebase Storage)
          const url = new URL(documento.link);
          const path = decodeURIComponent(url.pathname.split('/o/')[1].split('?')[0]);
          const fileRef = ref(storage, path);
          await deleteObject(fileRef);
          console.log("Archivo eliminado del storage:", path);
        } catch (storageError) {
          console.error("Error eliminando archivo del storage:", storageError);
          // No fallar completamente si el archivo no existe
        }
      }

      if (documento.linkFirmado) {
        try {
          const url = new URL(documento.linkFirmado);
          const path = decodeURIComponent(url.pathname.split('/o/')[1].split('?')[0]);
          const fileRef = ref(storage, path);
          await deleteObject(fileRef);
          console.log("Archivo firmado eliminado del storage:", path);
        } catch (storageError) {
          console.error("Error eliminando archivo firmado del storage:", storageError);
        }
      }

      // 2. Eliminar registros de Firestore
      const dniActual = dni.trim(); // Usar el DNI actual de la búsqueda

      if (esInstanciaLegajo) {
        // Si es instancia, borrar SOLO del legajo
        if (documento.legajoId || documento.id) {
          const idBorrar = documento.legajoId || documento.id;
          const docLegajoRef = doc(db, `onboarding/${dniActual}/legajo`, idBorrar);
          await deleteDoc(docLegajoRef);
          console.log("Documento de legajo eliminado:", idBorrar);
        }
      } else {
        // Si es asignación, borrar de la lista de asignados
        if (documento.id) {
          const docAsignadoRef = doc(db, `onboarding/${dniActual}/documentos`, documento.id);
          await deleteDoc(docAsignadoRef);
          console.log("Documento asignado eliminado:", documento.id);
        }
      }

      // AUDITORÍA
      try {
        await logBusinessAction("ELIMINACION_DOCUMENTO_ONBOARDING", "GestionOnboarding", {
          dniEditado: dniActual,
          cambiosRealizados: {
            [documento.title || documento.nombre || "Documento"]: {
              anterior: "Asignado/En legajo",
              nuevo: "Eliminado"
            }
          },
          origenEliminacion: esInstanciaLegajo ? "legajo" : "asignacion",
          idDocumento: documento.id || documento.legajoId
        }, usuario);
      } catch (e) {
        console.warn("No se pudo registrar la auditoría", e);
      }

      // 3. Recargar la búsqueda para refrescar la lista correctamente
      // (Es más seguro recargar que manipular el estado local con esta nueva lógica compleja)
      await buscarPorDNI();

      Swal.fire({
        title: 'Eliminado',
        text: 'El documento ha sido eliminado correctamente.',
        icon: 'success',
        timer: 2000,
        showConfirmButton: false
      });

    } catch (error) {
      console.error("Error eliminando documento:", error);
      Swal.fire({
        title: 'Error',
        text: `No se pudo eliminar el documento: ${error.message}`,
        icon: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  // Abrir documento en modal
  const verDocumento = (documento) => {
    setDocumentoSeleccionado(documento);
    setShowModal(true);
  };

  // Obtener el tipo de documento desde la lista maestra
  const obtenerTipoDocumento = (documentId) => {
    if (!documentId || !documentosMaestros.length) return { type: "upload" };
    const documento = documentosMaestros.find(doc => doc.id === documentId);
    return documento || { type: "upload" };
  };

  // Filtrar documentos según la pestaña activa
  const documentosFiltrados = documentos.filter(doc => {
    if (activeTab === 'todos') return true;
    if (activeTab === 'pendientes') return !doc.linkFirmado && !doc.fechaVista && doc.estado !== "completado";
    if (activeTab === 'firmados') return doc.linkFirmado || doc.fechaVista || doc.estado === "completado";
    if (activeTab === 'firma') return doc.type === "sign";
    if (activeTab === 'carga') return doc.type === "upload";
    return true;
  });

  // Renderizar estado del documento
  const renderEstadoDocumento = (documento) => {
    // 1. Si ya está firmado (Caso Exitoso definitivo)
    if (documento.linkFirmado) {
      return (
        <Badge bg="success" className="d-flex align-items-center gap-1">
          <FaCheck /> Firmado
        </Badge>
      );
    }

    // 2. Si requiere firma y NO está firmado (aunque esté visto) - Caso Pendiente Firma
    if (documento.type === 'sign' && !documento.linkFirmado) {
      if (documento.fechaVista || documento.contador > 0) {
        return (
          <Badge bg="warning" className="d-flex align-items-center gap-1" text="dark">
            <FaEye /> Visto
          </Badge>
        );
      }
      return (
        <Badge bg="secondary" className="d-flex align-items-center gap-1">
          <FaRegClock /> Pendiente
        </Badge>
      );
    }

    // 3. Si no requiere firma (Upload/Lectura) y está completado/visto - Caso Exitoso
    if (documento.fechaVista || documento.estado === "completado" || documento.estadoEnLegajo === "firmado") {
      return (
        <Badge bg="success" className="d-flex align-items-center gap-1">
          <FaCheck /> Completado
        </Badge>
      );
    } else if (documento.contador > 0 || documento.estadoEnLegajo === "visto") {
      return (
        <Badge bg="warning" className="d-flex align-items-center gap-1" text="dark">
          <FaEye /> Visto
        </Badge>
      );
    } else {
      return (
        <Badge bg="secondary" className="d-flex align-items-center gap-1">
          <FaRegClock /> Pendiente
        </Badge>
      );
    }
  };

  // Obtener ID para mostrar (documentId o id original) como texto
  const obtenerIdMostrar = (documento) => {
    return documento.documentId || documento.idDocument || documento.id;
  };

  // Obtener ID como número para ordenamiento
  const obtenerIdNumerico = (documento) => {
    const idStr = documento.documentId || documento.idDocument || documento.id;
    const idNum = parseInt(idStr, 10);
    return isNaN(idNum) ? 0 : idNum;
  };

  // Formatear fecha para Perú
  const formatearFechaPeru = (fecha) => {
    if (!fecha) return "-";
    if (typeof fecha === "object" && typeof fecha.toDate === "function") {
      return fecha.toDate().toLocaleString("es-PE", { timeZone: "America/Lima" });
    }
    if (typeof fecha === "string") {
      const dateObj = new Date(fecha);
      if (!isNaN(dateObj.getTime())) {
        return dateObj.toLocaleString("es-PE", { timeZone: "America/Lima" });
      }
      return fecha;
    }
    if (fecha instanceof Date) {
      return fecha.toLocaleString("es-PE", { timeZone: "America/Lima" });
    }
    return "-";
  };

  // Función para limpiar búsqueda
  const limpiarBusqueda = () => {
    setDni("");
    setDatosUsuario(null);
    setDocumentos([]);
    setDocumentosAsignados([]);
    setError(null);
    setProgreso(0);
  };

  return (
    <div
      className="min-vh-100"
      style={{
        background: "linear-gradient(135deg, #ffffff 0%, #ffffff 100%)",
        minHeight: "100vh",
        width: "100vw",
        maxWidth: "100%",
        padding: "20px 0",
      }}
    >
      <Container fluid style={{ width: "90%", maxWidth: "100%" }}>
        {/* Marco principal */}
        <Card
          className="shadow-lg border-0"
          style={{
            borderRadius: "15px",
            overflow: "hidden",
            minHeight: "90vh",
          }}
        >
          {/* Header Premium */}
          <Card.Header
            className="text-white py-4 position-relative"
            style={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              borderBottom: "3px solid #f39c12",
            }}
          >
            <div style={{position:"relative",display:"flex",alignItems:"center",justifyContent:"center"}} className="w-100">

              <div className="text-center">
                <h2 className="fw-bold mb-1">
                  <FaChartPie className="me-3" />
                  Seguimiento de Documentos Onboarding
                </h2>
                <p className="mb-0 opacity-75">
                  Sistema de seguimiento y control de documentos por empleado
                </p>
              </div>
              <div style={{position:"absolute",right:"20px"}}>
                <BotonManualHeader usuario={usuario} />
              </div>
            </div>
          </Card.Header>

          <Card.Body className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
            {/* Formulario de búsqueda */}
            <Card className="shadow-sm border-0 mb-4">
              <Card.Body className="p-4">
                <Form onSubmit={(e) => { e.preventDefault(); buscarPorDNI(); }}>
                  <Row className="align-items-end">
                    <Col md={6} lg={6}>
                      <Form.Group className="mb-3 mb-md-0">
                        <Form.Label className="fw-semibold text-dark">
                          <FaIdCard className="me-2" />
                          Buscar por DNI
                        </Form.Label>
                        <InputGroup>
                          <Form.Control
                            type="text"
                            value={dni}
                            onChange={(e) => setDni(e.target.value)}
                            placeholder="Ingrese DNI del trabajador"
                            className="form-control-lg"
                            maxLength={9}
                            disabled={buscando}
                            style={{ borderRadius: "10px 0 0 10px" }}
                          />
                          <Button
                            variant="primary"
                            onClick={buscarPorDNI}
                            disabled={buscando || !dni.trim()}
                            className="d-flex align-items-center"
                            style={{
                              borderRadius: "0 10px 10px 0",
                              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                              border: "none",
                            }}
                          >
                            {buscando ? (
                              <Spinner animation="border" size="sm" />
                            ) : (
                              <FaSearch />
                            )}
                            <span className="ms-2">Buscar</span>
                          </Button>
                        </InputGroup>
                      </Form.Group>
                    </Col>
                    <Col md={3} lg={3}>
                      <Button
                        variant="outline-secondary"
                        size="lg"
                        onClick={limpiarBusqueda}
                        disabled={buscando}
                        style={{ borderRadius: "10px" }}
                        title="Limpiar búsqueda"
                      >
                        <FaTimes />
                      </Button>
                    </Col>
                    <Col md={3} lg={3}>
                      <Form.Text className="text-muted d-block">
                        Ingrese el número de DNI del trabajador para visualizar su progreso de onboarding
                      </Form.Text>
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>

            {/* Mensajes de error */}
            {error && (
              <Alert variant="warning" className="border-0 shadow-sm mb-4" style={{ borderRadius: "10px" }}>
                <div className="d-flex align-items-center">
                  <FaExclamationTriangle className="me-3 fs-4" />
                  <div>
                    <h6 className="fw-bold mb-1">Error en la consulta</h6>
                    <p className="mb-0">{error}</p>
                  </div>
                </div>
              </Alert>
            )}

            {/* Información del usuario y progreso */}
            {datosUsuario && (
              <Card className="mb-4 border-0 shadow-sm" style={{ borderRadius: "15px" }}>
                <Card.Body className="p-4">
                  <Row className="align-items-center">
                    <Col md={1}>
                      <div
                        className="rounded-3 p-3 text-center"
                        style={{
                          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          color: "white"
                        }}
                      >
                        <FaUsers size={24} />
                      </div>
                    </Col>
                    <Col md={7}>
                      <h5 className="mb-2 fw-bold">
                        {datosUsuario.name} {datosUsuario.apellidos}
                      </h5>
                      <Row>
                        <Col md={6}>
                          <div className="text-muted small mb-1">
                            <strong>DNI:</strong> {dni}
                          </div>
                          <div className="text-muted small mb-1">
                            <strong>Email:</strong> {datosUsuario.email}
                          </div>
                        </Col>
                        <Col md={6}>
                          {datosUsuario.telefono && (
                            <div className="text-muted small mb-1">
                              <strong>Teléfono:</strong> {datosUsuario.telefono}
                            </div>
                          )}
                          {datosUsuario.cargo && (
                            <div className="text-muted small mb-1">
                              <strong>Cargo:</strong> {datosUsuario.cargo}
                            </div>
                          )}
                        </Col>
                      </Row>
                    </Col>
                    <Col md={4}>
                      <div className="text-center">
                        <h6 className="mb-2 fw-semibold">Progreso de Onboarding</h6>
                        <ProgressBar
                          now={progreso}
                          label={`${progreso}%`}
                          variant={progreso === 100 ? "success" : progreso > 60 ? "info" : "primary"}
                          className="mb-2"
                          style={{ height: "20px", borderRadius: "10px" }}
                        />
                        <Badge bg={progreso === 100 ? "success" : "primary"} className="px-3 py-2">
                          {progreso === 100 ? "✅ Completado" : "🔄 En progreso"}
                        </Badge>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            )}

            {/* Lista de documentos con pestañas */}
            {(datosUsuario || ambitoReporte === "masivo") && (
                <Card className="border-0 shadow-sm mb-4" style={{ borderRadius: "15px", backgroundColor: "#f8f9ff", border: "1px solid #e0e7ff" }}>
                    <Card.Body className="py-3">
                        <Row className="align-items-center g-3">
                            <Col lg={2} md={12}>
                                <div className="d-flex align-items-center">
                                    <FaFilePdf className="text-danger me-2" size={24} />
                                    <h6 className="mb-0 fw-bold">Reporte PDF</h6>
                                </div>
                            </Col>
                            
                            <Col lg={3} md={6}>
                                <Form.Group>
                                    <div className="d-flex gap-3">
                                        <Form.Check
                                            type="radio"
                                            label="Individual"
                                            name="ambito"
                                            id="radio-individual"
                                            checked={ambitoReporte === "individual"}
                                            onChange={() => setAmbitoReporte("individual")}
                                            className="small fw-semibold"
                                        />
                                        <Form.Check
                                            type="radio"
                                            label="Masivo (Todos)"
                                            name="ambito"
                                            id="radio-masivo"
                                            checked={ambitoReporte === "masivo"}
                                            onChange={() => setAmbitoReporte("masivo")}
                                            className="small fw-semibold"
                                        />
                                    </div>
                                </Form.Group>
                            </Col>

                            {ambitoReporte === "masivo" && (
                                <Col lg={3} md={6}>
                                    <Form.Select
                                        size="sm"
                                        value={documentoMasivo}
                                        onChange={(e) => setDocumentoMasivo(e.target.value)}
                                        className="rounded-3 border-primary"
                                        style={{ color: "#000", backgroundColor: "#fff" }}
                                    >
                                        <option value="" style={{ color: "#000" }}>-- Seleccionar Documento --</option>
                                        {documentosMaestros.map(doc => {
                                            const nombreDoc = doc.nombre || doc.titulo || doc.title || doc.tipo || "Sin nombre";
                                            return (
                                                <option key={doc.id} value={nombreDoc} style={{ color: "#000" }}>
                                                    {doc.id} - {nombreDoc}
                                                </option>
                                            );
                                        })}
                                    </Form.Select>
                                </Col>
                            )}

                            <Col lg={ambitoReporte === "masivo" ? 1 : 2} md={3}>
                                <Form.Select 
                                    size="sm" 
                                    value={mesReporte} 
                                    onChange={(e) => setMesReporte(e.target.value)}
                                    className="rounded-3"
                                >
                                    <option value="1">Enero</option>
                                    <option value="2">Febrero</option>
                                    <option value="3">Marzo</option>
                                    <option value="4">Abril</option>
                                    <option value="5">Mayo</option>
                                    <option value="6">Junio</option>
                                    <option value="7">Julio</option>
                                    <option value="8">Agosto</option>
                                    <option value="9">Septiembre</option>
                                    <option value="10">Octubre</option>
                                    <option value="11">Noviembre</option>
                                    <option value="12">Diciembre</option>
                                </Form.Select>
                            </Col>
                            <Col lg={ambitoReporte === "masivo" ? 1 : 2} md={3}>
                                <Form.Select 
                                    size="sm" 
                                    value={anoReporte} 
                                    onChange={(e) => setAnoReporte(e.target.value)}
                                    className="rounded-3"
                                >
                                    <option value="2023">2023</option>
                                    <option value="2024">2024</option>
                                    <option value="2025">2025</option>
                                    <option value="2026">2026</option>
                                </Form.Select>
                            </Col>
                            <Col lg={2} md={6}>
                                <Button 
                                    variant="danger" 
                                    size="sm" 
                                    className="w-100 fw-bold d-flex align-items-center justify-content-center h-100"
                                    onClick={handleExportarPDF}
                                    disabled={exportando}
                                    style={{ borderRadius: "8px", padding: "8px" }}
                                >
                                    {exportando ? <Spinner animation="border" size="sm" className="me-2" /> : <FaDownload className="me-2" />}
                                    {ambitoReporte === "masivo" ? "DESCARGAR MASIVO" : "DESCARGAR PDF"}
                                </Button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            )}

            {datosUsuario && !buscando && (
              <Card className="border-0 shadow-sm" style={{ borderRadius: "15px" }}>
                <Card.Header className="bg-primary text-white py-3">
                  <div className="d-flex align-items-center">
                    <FaFileAlt className="me-2" />
                    <div className="flex-grow-1">
                      <h5 className="mb-0 fw-semibold">Documentos del Empleado</h5>
                      <small className="opacity-75">
                        Estado actual de todos los documentos asignados
                      </small>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <Badge bg="light" text="primary" style={{ fontSize: "0.9rem" }}>
                        {documentos.length} documentos
                      </Badge>
                    </div>
                  </div>
                </Card.Header>

                {/* Pestañas de filtro */}
                <Card.Body className="p-0 bg-light border-bottom">
                  <Tabs
                    activeKey={activeTab}
                    onSelect={(k) => setActiveTab(k)}
                    className="px-4 pt-3 mb-0"
                    style={{ borderBottom: "none" }}
                  >
                    <Tab
                      eventKey="todos"
                      title={
                        <span>
                          <FaFileAlt className="me-1" />
                          Todos ({documentos.length})
                        </span>
                      }
                    />
                    <Tab
                      eventKey="pendientes"
                      title={
                        <span>
                          <FaRegClock className="me-1" />
                          Pendientes ({documentos.filter(doc => !doc.linkFirmado && !doc.fechaVista && doc.estado !== "completado").length})
                        </span>
                      }
                    />
                    <Tab
                      eventKey="firmados"
                      title={
                        <span>
                          <FaCheck className="me-1" />
                          Completados ({documentos.filter(doc => doc.linkFirmado || doc.fechaVista || doc.estado === "completado").length})
                        </span>
                      }
                    />
                    <Tab
                      eventKey="firma"
                      title={
                        <span>
                          <FaSignature className="me-1" />
                          Firma Digital ({documentos.filter(doc => doc.type === "sign").length})
                        </span>
                      }
                    />
                    <Tab
                      eventKey="carga"
                      title={
                        <span>
                          <FaUpload className="me-1" />
                          Carga ({documentos.filter(doc => doc.type === "upload").length})
                        </span>
                      }
                    />
                  </Tabs>
                </Card.Body>

                {/* Tabla de documentos */}
                <Card.Body className="p-0">
                  {documentos.length === 0 ? (
                    <div className="text-center py-5">
                      <div
                        className="bg-light rounded-circle mx-auto mb-3"
                        style={{
                          width: "80px",
                          height: "80px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FaInfoCircle size={32} className="text-muted" />
                      </div>
                      <h5 className="text-muted mb-2">Sin documentos asignados</h5>
                      <p className="text-muted">
                        No se encontraron documentos asignados a este trabajador
                      </p>
                    </div>
                  ) : documentosFiltrados.length === 0 ? (
                    <div className="text-center py-5">
                      <div
                        className="bg-light rounded-circle mx-auto mb-3"
                        style={{
                          width: "80px",
                          height: "80px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FaInfoCircle size={32} className="text-muted" />
                      </div>
                      <h5 className="text-muted mb-2">Sin resultados</h5>
                      <p className="text-muted">
                        No hay documentos que coincidan con el filtro actual
                      </p>
                    </div>
                  ) : (
                    <div style={{ maxHeight: "600px", overflowY: "auto" }}>
                      <Table hover responsive className="mb-0" style={{ fontSize: "0.9rem" }}>
                        <thead
                          style={{
                            backgroundColor: "#f8f9fa",
                            position: "sticky",
                            top: 0,
                            zIndex: 10,
                          }}
                        >
                          <tr>
                            <th className="border-0 py-3 px-3 text-secondary fw-semibold text-center" style={{ width: '8%' }}>
                              ID
                            </th>
                            <th className="border-0 py-3 px-3 text-secondary fw-semibold" style={{ width: '35%' }}>
                              Documento
                            </th>
                            <th className="border-0 py-3 px-3 text-secondary fw-semibold" style={{ width: '15%' }}>
                              Tipo
                            </th>
                            <th className="border-0 py-3 px-3 text-secondary fw-semibold" style={{ width: '15%' }}>
                              Fecha
                            </th>
                            <th className="border-0 py-3 px-3 text-secondary fw-semibold" style={{ width: '15%' }}>
                              Estado
                            </th>
                            <th className="border-0 py-3 px-3 text-secondary fw-semibold text-center" style={{ width: '12%' }}>
                              Acciones
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {documentosFiltrados.map((doc, index) => (
                            <tr key={doc.id}>
                              <td className="text-center py-3 px-3">
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip>
                                      {doc.origen === "legajo" ? "Documento en Legajo" : "Documento Maestro"}
                                    </Tooltip>
                                  }
                                >
                                  <Badge bg="dark" className="px-2 py-1">
                                    {obtenerIdNumerico(doc)}
                                  </Badge>
                                </OverlayTrigger>
                              </td>
                              <td className="py-3 px-3">
                                <div className="d-flex align-items-center">
                                  <div className="me-3">
                                    {doc.type === "sign" ? (
                                      <FaFileSignature className="text-primary" size={20} />
                                    ) : (
                                      <FaFileAlt className="text-success" size={20} />
                                    )}
                                  </div>
                                  <div>
                                    <div className="fw-medium text-dark">
                                      {doc.title || doc.nombre}
                                    </div>
                                    {(doc.description || doc.tipo) && (
                                      <small className="text-muted">
                                        {doc.description || doc.tipo}
                                      </small>
                                    )}
                                    {doc.obligatorio && (
                                      <Badge bg="danger" className="ms-2" pill size="sm">
                                        Obligatorio
                                      </Badge>
                                    )}
                                  </div>
                                </div>
                              </td>
                              <td className="py-3 px-3">
                                <Badge
                                  bg={doc.type === "sign" ? "info" : doc.type === "fill" ? "warning" : "success"}
                                  className="d-flex align-items-center justify-content-center"
                                  style={{ width: "fit-content", minWidth: "80px" }}
                                >
                                  {doc.type === "sign" ? (
                                    <>
                                      <FaSignature className="me-1" /> Firma
                                    </>
                                  ) : doc.type === "fill" ? (
                                    <>
                                      <FaEdit className="me-1" /> Formulario
                                    </>
                                  ) : (
                                    <>
                                      <FaUpload className="me-1" /> Carga
                                    </>
                                  )}
                                </Badge>
                              </td>
                              <td className="py-3 px-3">
                                <div className="text-dark">
                                  {doc.linkFirmado && doc.fechaFirma ? (
                                    <div>
                                      <div className="fw-medium">
                                        {formatearFechaPeru(doc.fechaFirma).split(' ')[0]}
                                      </div>
                                      <small className="text-muted">
                                        {formatearFechaPeru(doc.fechaFirma).split(' ')[1]}
                                      </small>
                                    </div>
                                  ) : doc.fechaVista ? (
                                    <div>
                                      <div className="fw-medium">
                                        {formatearFechaPeru(doc.fechaVista).split(' ')[0]}
                                      </div>
                                      <small className="text-muted">
                                        {formatearFechaPeru(doc.fechaVista).split(' ')[1]}
                                      </small>
                                    </div>
                                  ) : doc.fechaDoc ? (
                                    <div>
                                      <div className="fw-medium">
                                        {formatearFechaPeru(doc.fechaDoc).split(' ')[0]}
                                      </div>
                                      <small className="text-muted">
                                        {formatearFechaPeru(doc.fechaDoc).split(' ')[1]}
                                      </small>
                                    </div>
                                  ) : (
                                    <span className="text-muted">-</span>
                                  )}
                                </div>
                              </td>
                              <td className="py-3 px-3">
                                {renderEstadoDocumento(doc)}
                              </td>
                              <td className="text-center py-3 px-3">
                                <div className="d-flex gap-1 justify-content-center">
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Ver documento</Tooltip>}
                                  >
                                    <Button
                                      variant="outline-primary"
                                      size="sm"
                                      onClick={() => verDocumento(doc)}
                                      disabled={!doc.link}
                                      style={{ borderRadius: "6px" }}
                                    >
                                      <FaEye />
                                    </Button>
                                  </OverlayTrigger>

                                  {doc.link && (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={<Tooltip>Descargar</Tooltip>}
                                    >
                                      <Button
                                        variant="outline-success"
                                        size="sm"
                                        onClick={() => window.open(doc.link, '_blank')}
                                        style={{ borderRadius: "6px" }}
                                      >
                                        <FaDownload />
                                      </Button>
                                    </OverlayTrigger>
                                  )}

                                  {doc.linkFirmado && (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={<Tooltip>Descargar firmado</Tooltip>}
                                    >
                                      <Button
                                        variant="outline-info"
                                        size="sm"
                                        onClick={() => window.open(doc.linkFirmado, '_blank')}
                                        style={{ borderRadius: "6px" }}
                                      >
                                        <FaFileSignature />
                                      </Button>
                                    </OverlayTrigger>
                                  )}

                                  {/* Botón de eliminar */}
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip>Eliminar documento</Tooltip>}
                                  >
                                    <Button
                                      variant="outline-danger"
                                      size="sm"
                                      onClick={() => eliminarDocumento(doc)}
                                      disabled={loading}
                                      style={{ borderRadius: "6px" }}
                                    >
                                      <FaTrash />
                                    </Button>
                                  </OverlayTrigger>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </Card.Body>
              </Card>
            )}

            {/* Estado de carga */}
            {buscando && (
              <Card className="shadow-sm border-0" style={{ borderRadius: "15px" }}>
                <Card.Body className="py-5">
                  <div className="text-center">
                    <Spinner animation="border" variant="primary" style={{ width: "3rem", height: "3rem" }} />
                    <h5 className="mt-3 text-muted">Buscando documentos...</h5>
                    <p className="text-muted">Consultando el progreso de onboarding del empleado</p>
                  </div>
                </Card.Body>
              </Card>
            )}

            {/* Estado inicial */}
            {!datosUsuario && !buscando && !error && (
              <Card className="shadow-sm border-0" style={{ borderRadius: "15px" }}>
                <Card.Body className="py-5">
                  <div className="text-center">
                    <div
                      className="bg-light rounded-circle mx-auto mb-3"
                      style={{
                        width: "80px",
                        height: "80px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <FaSearch size={32} className="text-muted" />
                    </div>
                    <h5 className="text-muted mb-2">
                      Ingrese un DNI para consultar el progreso
                    </h5>
                    <p className="text-muted">
                      Utilice el campo de búsqueda para encontrar el progreso de onboarding de un empleado
                    </p>
                  </div>
                </Card.Body>
              </Card>
            )}
          </Card.Body>
        </Card>
      </Container>

      {/* Modal para ver documento */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton className="border-0 pb-2">
          <Modal.Title className="d-flex align-items-center">
            <div
              className="rounded-3 p-2 me-3"
              style={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "white",
              }}
            >
              <FaFileAlt />
            </div>
            <div>
              <div>{documentoSeleccionado?.title || documentoSeleccionado?.nombre}</div>
              <Badge bg="dark" className="mt-1">
                ID: {obtenerIdNumerico(documentoSeleccionado || {})}
              </Badge>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          {documentoSeleccionado?.link ? (
            <div className="ratio ratio-16x9" style={{ borderRadius: "10px", overflow: "hidden" }}>
              <iframe
                src={documentoSeleccionado.link}
                title={documentoSeleccionado.title || documentoSeleccionado.nombre}
                allowFullScreen
                style={{ border: "none" }}
              />
            </div>
          ) : (
            <div className="text-center py-5">
              <FaInfoCircle size={40} className="text-muted mb-3" />
              <h5 className="text-muted">No se puede mostrar el documento</h5>
              <p className="text-muted">El documento no está disponible para visualización</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          <Button
            variant="primary"
            onClick={() => window.open(documentoSeleccionado?.link, '_blank')}
            disabled={!documentoSeleccionado?.link}
            style={{
              borderRadius: "8px",
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              border: "none",
            }}
          >
            <FaDownload className="me-2" />
            Abrir en nueva ventana
          </Button>
          <Button
            variant="outline-secondary"
            onClick={() => setShowModal(false)}
            style={{ borderRadius: "8px" }}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default SeguimientoOnboarding;


